import { useEffect, useState } from 'react';
import { isMobile } from 'mobile-device-detect';
import { useErrorContext } from '../../../store/errorContext';
import { isDebugMode } from '../../../helpers/config';
import { useSDKWrapper } from '../../../helpers/sdkWrapper';

const Plug: React.FC = () => {
    const [isPortrait, setIsPortrait] = useState(false);
    const { error, setError } = useErrorContext();
    const { appExpand, verticalSwipeDisabled, openLink } = useSDKWrapper();

    useEffect(() => {
        document.body.style.overflowY = 'hidden';
        setIsPortrait(window.innerHeight < window.innerWidth);

        window.addEventListener(
            'orientationchange',
            () => {
                // Announce the new orientation number
                setIsPortrait(window.innerHeight < window.innerWidth);
            },
            false,
        );

        window.addEventListener(
            'resize',
            () => {
                // Announce the new orientation number
                setIsPortrait(window.innerHeight < window.innerWidth);
            },
            false,
        );

        window.addEventListener('online', () => {
            setError(null);
        });
        window.addEventListener('offline', () => {
            setError('You are offline. Please check your internet connection and try again.');
        });

        appExpand();
        verticalSwipeDisabled();

        // closingBehavior.enableConfirmation();

        //@ts-ignore
        window?.Telegram?.WebApp?.setHeaderColor('#000000');

        // eslint-disable-next-line
    }, []);

    return (
        <>
            {!isMobile && !isDebugMode() && (
                <div className="w-screen bg-black h-screen fixed flex items-center justify-center z-[100] flex-col gap-6">
                    <span className="text-white text-2xl font-druk">Use your mobile phone</span>
                </div>
            )}

            {!!error && (
                <div className="w-screen bg-black h-screen fixed flex items-center justify-center z-[100] flex-col gap-6">
                    <div className="flex flex-col gap-8">
                        <img src="/assets/maintenance.png" alt="maintenance" />
                        <div className="flex flex-col gap-4 px-4 align-center">
                            <span className="font-druk text-2xl font-bold leading-8 text-white text-center">
                                {error}
                            </span>
                            <span className="font-mono text-base text-[#B3B3B3] text-center">
                                Please come back later.
                            </span>
                        </div>
                        <div className="flex gap-8 justify-center">
                            <button
                                onClick={() => {
                                    openLink('https://t.me/roachracingclub');
                                }}
                                className="flex w-9 bg-[#1A1A1A] h-9 rounded-full items-center justify-center border border-[#2B2B2B] bg-[linear-gradient(0deg,_#1A1A1A_0%,_#1A1A1A_100%),_#FFF]"
                            >
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M14.6667 1.18656L12.3467 14.7231C12.3467 14.7231 12.0221 15.6616 11.1304 15.2115L5.77757 10.4614L5.75275 10.4474C6.47579 9.69596 12.0826 3.86145 12.3276 3.59698C12.7069 3.18738 12.4714 2.94354 12.031 3.25295L3.7491 9.34014L0.553966 8.09589C0.553966 8.09589 0.051146 7.88888 0.00277342 7.43877C-0.0462356 6.98792 0.570515 6.74408 0.570515 6.74408L13.5961 0.830006C13.5961 0.830006 14.6667 0.285598 14.6667 1.18656Z"
                                        fill="white"
                                    />
                                </svg>
                            </button>
                            {/*<div className="flex w-9 h-9 rounded-full items-center justify-center border border-[#2B2B2B] bg-[linear-gradient(0deg,_#1A1A1A_0%,_#1A1A1A_100%),_#FFF]">*/}
                            {/*    <svg*/}
                            {/*        width="16"*/}
                            {/*        height="16"*/}
                            {/*        viewBox="0 0 16 16"*/}
                            {/*        fill="none"*/}
                            {/*        xmlns="http://www.w3.org/2000/svg"*/}
                            {/*    >*/}
                            {/*        <path*/}
                            {/*            d="M8 1.44578C10.1205 1.44578 10.4096 1.44578 11.2771 1.44578C12.0482 1.44578 12.4337 1.63855 12.7229 1.73494C13.1084 1.92771 13.3976 2.0241 13.6867 2.31325C13.9759 2.60241 14.1687 2.89157 14.2651 3.27711C14.3614 3.56627 14.4578 3.95181 14.5542 4.72289C14.5542 5.59036 14.5542 5.78313 14.5542 8C14.5542 10.2169 14.5542 10.4096 14.5542 11.2771C14.5542 12.0482 14.3614 12.4337 14.2651 12.7229C14.0723 13.1084 13.9759 13.3976 13.6867 13.6867C13.3976 13.9759 13.1084 14.1687 12.7229 14.2651C12.4337 14.3614 12.0482 14.4578 11.2771 14.5542C10.4096 14.5542 10.2169 14.5542 8 14.5542C5.78313 14.5542 5.59036 14.5542 4.72289 14.5542C3.95181 14.5542 3.56627 14.3614 3.27711 14.2651C2.89157 14.0723 2.60241 13.9759 2.31325 13.6867C2.0241 13.3976 1.83133 13.1084 1.73494 12.7229C1.63855 12.4337 1.54217 12.0482 1.44578 11.2771C1.44578 10.4096 1.44578 10.2169 1.44578 8C1.44578 5.78313 1.44578 5.59036 1.44578 4.72289C1.44578 3.95181 1.63855 3.56627 1.73494 3.27711C1.92771 2.89157 2.0241 2.60241 2.31325 2.31325C2.60241 2.0241 2.89157 1.83133 3.27711 1.73494C3.56627 1.63855 3.95181 1.54217 4.72289 1.44578C5.59036 1.44578 5.87952 1.44578 8 1.44578ZM8 0C5.78313 0 5.59036 0 4.72289 0C3.85542 0 3.27711 0.192772 2.79518 0.385543C2.31325 0.578314 1.83133 0.867471 1.3494 1.3494C0.867471 1.83133 0.674699 2.21687 0.385543 2.79518C0.192772 3.27711 0.0963856 3.85542 0 4.72289C0 5.59036 0 5.87952 0 8C0 10.2169 0 10.4096 0 11.2771C0 12.1446 0.192772 12.7229 0.385543 13.2048C0.578314 13.6867 0.867471 14.1687 1.3494 14.6506C1.83133 15.1325 2.21687 15.3253 2.79518 15.6145C3.27711 15.8072 3.85542 15.9036 4.72289 16C5.59036 16 5.87952 16 8 16C10.1205 16 10.4096 16 11.2771 16C12.1446 16 12.7229 15.8072 13.2048 15.6145C13.6867 15.4217 14.1687 15.1325 14.6506 14.6506C15.1325 14.1687 15.3253 13.7831 15.6145 13.2048C15.8072 12.7229 15.9036 12.1446 16 11.2771C16 10.4096 16 10.1205 16 8C16 5.87952 16 5.59036 16 4.72289C16 3.85542 15.8072 3.27711 15.6145 2.79518C15.4217 2.31325 15.1325 1.83133 14.6506 1.3494C14.1687 0.867471 13.7831 0.674699 13.2048 0.385543C12.7229 0.192772 12.1446 0.0963856 11.2771 0C10.4096 0 10.2169 0 8 0Z"*/}
                            {/*            fill="white"*/}
                            {/*        />*/}
                            {/*        <path*/}
                            {/*            d="M8 3.85542C5.68675 3.85542 3.85542 5.68675 3.85542 8C3.85542 10.3133 5.68675 12.1446 8 12.1446C10.3133 12.1446 12.1446 10.3133 12.1446 8C12.1446 5.68675 10.3133 3.85542 8 3.85542ZM8 10.6988C6.55422 10.6988 5.30121 9.54217 5.30121 8C5.30121 6.55422 6.45783 5.30121 8 5.30121C9.44578 5.30121 10.6988 6.45783 10.6988 8C10.6988 9.44578 9.44578 10.6988 8 10.6988Z"*/}
                            {/*            fill="white"*/}
                            {/*        />*/}
                            {/*        <path*/}
                            {/*            d="M12.241 4.72289C12.7733 4.72289 13.2048 4.29136 13.2048 3.75904C13.2048 3.22671 12.7733 2.79518 12.241 2.79518C11.7086 2.79518 11.2771 3.22671 11.2771 3.75904C11.2771 4.29136 11.7086 4.72289 12.241 4.72289Z"*/}
                            {/*            fill="white"*/}
                            {/*        />*/}
                            {/*    </svg>*/}
                            {/*</div>*/}
                            {/*<div className="flex w-9 h-9 rounded-full items-center justify-center border border-[#2B2B2B] bg-[linear-gradient(0deg,_#1A1A1A_0%,_#1A1A1A_100%),_#FFF]">*/}
                            {/*    <svg*/}
                            {/*        width="16"*/}
                            {/*        height="16"*/}
                            {/*        viewBox="0 0 16 16"*/}
                            {/*        fill="none"*/}
                            {/*        xmlns="http://www.w3.org/2000/svg"*/}
                            {/*    >*/}
                            {/*        <path*/}
                            {/*            fillRule="evenodd"*/}
                            {/*            clipRule="evenodd"*/}
                            {/*            d="M1.64545 13.2611C1.36016 13.1767 1.09987 13.0264 0.886514 12.823C0.673163 12.6197 0.51302 12.3691 0.419598 12.0926C-0.114239 10.6634 -0.272414 4.69526 0.755718 3.51709C1.0979 3.13382 1.58101 2.89786 2.1002 2.86041C4.85836 2.57069 13.38 2.60932 14.3587 2.95698C14.634 3.04422 14.8855 3.19118 15.0943 3.38685C15.3032 3.58253 15.464 3.82184 15.5648 4.08686C16.148 5.5644 16.1678 10.9338 15.4857 12.3533C15.3047 12.7229 15.0018 13.0222 14.6256 13.2032C13.5975 13.7053 3.0097 13.6957 1.64545 13.2611ZM6.02489 10.4606L10.9678 7.94971L6.02489 5.41954V10.4606Z"*/}
                            {/*            fill="white"*/}
                            {/*        />*/}
                            {/*    </svg>*/}
                            {/*</div>*/}
                            <a
                                href="https://x.com/roachracingclub"
                                className="flex w-9 bg-[#1A1A1A] h-9 rounded-full items-center justify-center border border-[#2B2B2B] bg-[linear-gradient(0deg,_#1A1A1A_0%,_#1A1A1A_100%),_#FFF]"
                            >
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M5.99386 8.38403L0 2H4.74756L8.44753 5.94577L12.4004 2.01777H15.0151L9.71175 7.29399L16 14H11.2666L7.2603 9.7329L2.98317 13.9882H0.354296L5.99386 8.38403ZM11.9565 12.8172L2.91105 3.18285H4.0571L13.0912 12.8172H11.9565Z"
                                        fill="white"
                                    />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            )}
            {isPortrait && (
                <div className="w-screen bg-black h-screen fixed flex items-center justify-center z-[100] flex-col gap-6">
                    <span className="text-white text-xl">Please rotate your screen</span>
                    <svg height="48px" width="48px" version="1.1" viewBox="0 0 24 24">
                        <g fill="none" id="Page-1" stroke="none">
                            <g fill="white" transform="translate(-210.000000, -124.000000)">
                                <g transform="translate(210.000000, 124.000000)">
                                    <path d="M16.5,2.5 C19.8,4 22.1,7.2 22.5,11 L24,11 C23.4,4.8 18.3,0 12,0 L11.3,0 L15.1,3.8 L16.5,2.5 L16.5,2.5 Z M10.2,1.7 C9.6,1.1 8.7,1.1 8.1,1.7 L1.7,8.1 C1.1,8.7 1.1,9.6 1.7,10.2 L13.7,22.2 C14.3,22.8 15.2,22.8 15.8,22.2 L22.2,15.8 C22.8,15.2 22.8,14.3 22.2,13.7 L10.2,1.7 L10.2,1.7 Z M14.8,21.2 L2.8,9.2 L9.2,2.8 L21.2,14.8 L14.8,21.2 L14.8,21.2 Z M7.5,21.5 C4.2,20 1.9,16.8 1.5,13 L0.1,13 C0.6,19.2 5.7,24 12,24 L12.7,24 L8.9,20.2 L7.5,21.5 L7.5,21.5 Z" />
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
            )}
        </>
    );
};

export { Plug };
